// 自定义查找元素是否在某个数组，是返回索引，否返回-1
Array.prototype.idxOf = function(val) {
  for (var i = 0; i < this.length; i++) {
    if (this[i] == val) return i;
  }
  return -1;
};
// 从数组中删除元素
Array.prototype.remove = function(val) {
  var index = this.idxOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};
// 从数组中删除对象
Array.prototype.removeArrObj = function(obj) {
    var index = null;
    var key = Object.keys(obj)[0];
    this.every(function(value, i) {
        if (value[key] === obj[key]) {
            index = i;
            return false;
        }
        return true;
    });
    if (index != null) {
        this.splice(index, 1);
    }
};

export default Array.prototype